export default function isEqualRef(ref1, ref2) {
	const bothNull = !ref1 && !ref2;
	const equal = !!ref1 && !!ref2 && ref1.isEqual(ref2);

	return bothNull || equal;
}
